import { useState, useEffect, useRef } from 'react'

const PASO_DATOS = 'datos'
const PASO_CHAT  = 'chat'

function validarEmail(v) { return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v) }
function validarTel(v)   { return /^\d{7,15}$/.test(v.replace(/[\s\-]/g, '')) }

// CON-02: "Hablar con un asesor" enruta a la línea de asesoría directa (WhatsApp 311 334 4265).
const WA_URL = 'https://wa.me/573113344265?text=Hola%2C%20quiero%20contactar%20a%20un%20asesor%20de%20ACER%20Seguros'

function renderMsg(text) {
  // Detecta [texto](url) y URLs sueltas, limpia puntuación final
  const combined = /(\[([^\]]+)\]\((https?:\/\/[^)]+)\))|(https?:\/\/[^\s)"]+)/g
  const result = []
  let last = 0, m
  while ((m = combined.exec(text)) !== null) {
    if (m.index > last) result.push(text.slice(last, m.index))
    if (m[1]) {
      // markdown [label](url)
      result.push(
        <a key={m.index} href={m[3]} target="_blank" rel="noopener noreferrer"
           style={{ color: '#25D366', fontWeight: 700, textDecoration: 'underline' }}>
          {m[2]}
        </a>
      )
    } else {
      // URL suelta — quita puntuación final (, . ) ; :)
      const url = m[0].replace(/[.,);:!]+$/, '')
      const trail = m[0].slice(url.length)
      result.push(
        <a key={m.index} href={url} target="_blank" rel="noopener noreferrer"
           style={{ color: '#25D366', fontWeight: 700, textDecoration: 'underline', wordBreak: 'break-all' }}>
          {url}
        </a>
      )
      if (trail) result.push(trail)
    }
    last = m.index + m[0].length
  }
  if (last < text.length) result.push(text.slice(last))
  return result
}

export default function FloatingChat() {
  const [visible, setVisible]   = useState(false)
  const [open, setOpen]         = useState(false)
  const [paso, setPaso]         = useState(PASO_DATOS)

  // Datos del usuario
  const [nombre,   setNombre]   = useState('')
  const [telefono, setTelefono] = useState('')
  const [correo,   setCorreo]   = useState('')
  const [errDatos, setErrDatos] = useState('')

  // Chat
  const [mensajes, setMensajes] = useState([])
  const [input,    setInput]    = useState('')
  const [cargando, setCargando] = useState(false)
  const [errChat,  setErrChat]  = useState('')

  const bodyRef = useRef(null)

  useEffect(() => {
    const t = setTimeout(() => setVisible(true), 1500)
    return () => clearTimeout(t)
  }, [])

  // Scroll al último mensaje
  useEffect(() => {
    if (bodyRef.current) bodyRef.current.scrollTop = bodyRef.current.scrollHeight
  }, [mensajes, cargando])

  const handleDatos = e => {
    e.preventDefault()
    setErrDatos('')
    if (!nombre.trim())           return setErrDatos('Ingresa tu nombre')
    if (!validarTel(telefono))    return setErrDatos('Ingresa un teléfono válido (solo dígitos)')
    if (!validarEmail(correo))    return setErrDatos('Ingresa un correo válido')

    setPaso(PASO_CHAT)
    setMensajes([{
      role: 'assistant',
      content: `¡Hola ${nombre.split(' ')[0]}! 👋 Soy Arci, el asistente virtual de ACER Seguros. ¿En qué puedo ayudarte hoy? Puedo orientarte sobre seguros de automóvil, hogar, vida, empresas, ARL, SG-SST y más.`
    }])
  }

  const enviarMensaje = async e => {
    e.preventDefault()
    const texto = input.trim()
    if (!texto || cargando) return
    setInput('')
    setErrChat('')

    const nuevosMensajes = [...mensajes, { role: 'user', content: texto }]
    setMensajes(nuevosMensajes)
    setCargando(true)

    try {
      const res = await fetch('/api/chat', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ nombre, telefono, correo, mensajes: nuevosMensajes }),
      })
      const data = await res.json()
      if (res.ok) {
        setMensajes(p => [...p, { role: 'assistant', content: data.respuesta }])
      } else {
        setErrChat(data.error || 'Error al conectar con el asistente.')
      }
    } catch {
      setErrChat('No se pudo conectar. Verifica tu conexión e intenta de nuevo.')
    } finally {
      setCargando(false)
    }
  }

  return (
    <>
      {/* BOTÓN FLOTANTE — se oculta cuando el panel está abierto */}
      {!open && (
        <button
          className={`float-chat-btn${visible ? ' float-chat-btn-show' : ''}`}
          onClick={() => setOpen(true)}
          aria-label="Chat con ACER Seguros"
        >
          <img src="/chat-dog-1.webp" alt="Asistente ACER" />
          <span className="float-chat-label">Hola soy <strong>Arci</strong> tu asistente</span>
        </button>
      )}

      {/* PANEL */}
      <div className={`float-chat-panel${open ? ' float-chat-panel-open' : ''}`}>

        {/* HEADER */}
        <div className="float-chat-header">
          <div className="float-chat-header-info">
            <img src="/chat-dog-1.webp" alt="" className="float-chat-avatar" />
            <div>
              <div className="float-chat-name">Asistente ACER Seguros</div>
              <div className="float-chat-status">● En línea</div>
            </div>
          </div>
          <button className="float-chat-close" onClick={() => setOpen(false)} aria-label="Cerrar">✕</button>
        </div>

        {/* PASO 1 — FORMULARIO DE DATOS */}
        {paso === PASO_DATOS && (
          <div className="float-chat-body" style={{ padding: '1.25rem', display: 'flex', flexDirection: 'column', gap: '0.75rem' }}>
            <div className="float-chat-msg float-chat-msg-bot">
              <img src="/chat-dog-1.webp" alt="" className="float-chat-msg-avatar" />
              <div className="float-chat-bubble" style={{ fontSize: '0.85rem', lineHeight: 1.55 }}>
                Bienvenido a ACER Seguros, mi nombre es <strong>Arci</strong>. Es un gusto saludarte. 😊<br /><br />
                Te recuerdo que tus datos están protegidos por la <strong>Ley 1581 de 2012</strong> de protección de datos personales.<br /><br />
                Te agradezco si me compartes la siguiente información:
              </div>
            </div>
            <form onSubmit={handleDatos} style={{ display: 'flex', flexDirection: 'column', gap: '0.625rem' }}>
              <input
                className="contact-input"
                style={{ fontSize: '0.875rem', padding: '0.6rem 0.875rem' }}
                placeholder="Tu nombre completo *"
                value={nombre}
                onChange={e => setNombre(e.target.value)}
                autoComplete="name"
              />
              <input
                className="contact-input"
                style={{ fontSize: '0.875rem', padding: '0.6rem 0.875rem' }}
                placeholder="Número de teléfono *"
                value={telefono}
                onChange={e => setTelefono(e.target.value)}
                inputMode="tel"
                autoComplete="tel"
              />
              <input
                className="contact-input"
                style={{ fontSize: '0.875rem', padding: '0.6rem 0.875rem' }}
                placeholder="Tu correo electrónico *"
                value={correo}
                onChange={e => setCorreo(e.target.value)}
                inputMode="email"
                autoComplete="email"
              />
              {errDatos && (
                <div style={{ fontSize: '0.8rem', color: 'var(--crimson)', padding: '0.4rem 0' }}>{errDatos}</div>
              )}
              <button type="submit" className="btn btn-primary" style={{ width: '100%', justifyContent: 'center', marginTop: '0.25rem' }}>
                Iniciar chat →
              </button>
            </form>
          </div>
        )}

        {/* PASO 2 — CHAT */}
        {paso === PASO_CHAT && (
          <>
            <div className="float-chat-body" ref={bodyRef}>
              {mensajes.map((m, i) => (
                <div
                  key={i}
                  className={`float-chat-msg${m.role === 'user' ? ' float-chat-msg-user' : ' float-chat-msg-bot'}`}
                >
                  {m.role === 'assistant' && (
                    <img src="/chat-dog-1.webp" alt="" className="float-chat-msg-avatar" />
                  )}
                  <div className="float-chat-bubble">{renderMsg(m.content)}</div>
                </div>
              ))}

              {cargando && (
                <div className="float-chat-msg float-chat-msg-bot">
                  <img src="/chat-dog-1.webp" alt="" className="float-chat-msg-avatar" />
                  <div className="float-chat-bubble float-chat-typing">
                    <span /><span /><span />
                  </div>
                </div>
              )}

              {errChat && (
                <div className="float-chat-error">{errChat}</div>
              )}
            </div>

            <a href={WA_URL} target="_blank" rel="noopener noreferrer" className="float-chat-wa-cta">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor"><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/></svg>
              Hablar con un asesor
            </a>

            <form className="float-chat-input-row" onSubmit={enviarMensaje}>
              <input
                className="float-chat-input"
                placeholder="Escribe tu pregunta…"
                value={input}
                onChange={e => setInput(e.target.value)}
                disabled={cargando}
              />
              <button type="submit" className="float-chat-send" disabled={cargando || !input.trim()} aria-label="Enviar">
                ➤
              </button>
            </form>
          </>
        )}
      </div>
    </>
  )
}

